import axios from "axios";

const api_url = process.env.REACT_APP_API_URL + "/productos";

export async function getProductos(marcaId, nombre = '', incluyeInactivos = false) {
    let params = "";
    if (marcaId) {
        params += "?marca="+marcaId;
    }
    if (nombre) {
        params += (params===""?"?nombre="+nombre:"&descripcion="+nombre);
    }
    if (incluyeInactivos) {
        params += (params===""?"?estado=T":"&estado=T");
    }
    try {
        let resp = await axios.get(api_url+params);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            message: ""
        }
        if (err.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al obtener datos de productos desde el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
    
}

export async function importarProductos(data) {
    /*
    https://rapidapi.com/guides/upload-files-react-axios
    */

    try {
        let resp = await axios.post(api_url+"/upload", data, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
        });
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            messages: []
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.messages = err.response.data.mensajes;
            } else {
                resp.messages.push("Hubo un error al importar los productos en el servidor.");
            }
            //develver error segun estado
        } else {
            resp.messages.push("Hubo un error al intentar conectar con el servidor.");
            //develver error de red
        }
        return resp;
    }
}

export async function nuevoProducto(data) {
    try {
        let resp = await axios.post(api_url,data);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            messages: []
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.messages = err.response.data.mensajes;
            } else {
                resp.messages.push("Hubo un error al guardar el producto en el servidor.");
            }
            //develver error segun estado
        } else {
            resp.messages.push("Hubo un error al intentar conectar con el servidor.");
            //develver error de red
        }
        return resp;
    }
}

export async function editarProducto(id, data) {
    try {
        let resp = await axios.put(api_url+`/${id}`,data);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            messages: []
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.messages = err.response.data.mensajes;
            } else {
                resp.messages.push("Hubo un error al guardar el producto en el servidor.");
            }
            //devolver error segun estado
        } else {
            resp.messages.push("Hubo un error al intentar conectar con el servidor.");
            //devolver error de red
        }
        return resp;
    }
}

export async function getProducto(id) {
    try {
        let resp = await axios.get(api_url+"/"+id);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            message: ""
        }
        if (err.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al obtener el producto en el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}

export async function deleteProduct(id) {
    try {
        let resp = await axios.delete(api_url+"/"+id);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            message: ""
        }
        if (err.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al borrar el producto en el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}